export default {
  accountCreated:
    'Вашият акаунт е създаден. Моля, проверете електронната си поща и следвайте процедурата за валидиране. След като това стане, ще можете да конфигурирате акаунта си. Забавлявайте се с настройките!',
  FAILED_TO_ACTIVATE:
    'Нещо се случи и не успяхме да активираме вашия акаунт. Моля, проверете електронната си поща или се свържете с нашия екип за поддръжка на contact@sporya.net',
  SUCCESSFULLY_ACTIVATED:
    'Поздравления! Успешно активирахте акаунта си. Вече можете да влезете, за да продължите да настройвате акаунта си!',
};
